// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_05a1321","cell":"_f2a2957","cellExpand":"_c9362a2","cellIcon":"_5baf0f3","cellStartStateLateReg":"_40f1a40","cellName":"_6553400","cellPrizePool":"_9f66c3f"};